module.exports = __webpack_public_path__ + "img/mb_Payments.5325f05a.svg";